import { withInstall } from '../../utils';
import Table from './src/table.vue';

export * from './src/table';

export const ITable = withInstall(Table); // 增加类型

export default ITable;
